import React, {useCallback, useEffect, useState} from "react"
import {loadStripe} from '@stripe/stripe-js';

interface Params {
  eventcode: string
  orders: string
  historyid: string
}

const StripeCheckout = () => {
  const [stripePromise, setStripePromise] = useState(null)
  const apiKey = 'pk_test_51P2E9hEx8pB9i4Ty1Or1lBsLtvKvVPdYtr6MWSQVQTCbyUFeQzLytcwsuHjtvu5ote3nYFfye4cQFmAyIQlfGlcv00kAWBhGW2'


  const loadStripeAccount = async () => {
    setStripePromise(await loadStripe(apiKey));
  }

  useEffect(() => {
    if (stripePromise) {
      const elements = stripePromise.elements(options);
      const paymentElementOptions = {
        layout: {
          type: 'tabs',
          defaultCollapsed: false,
        },
        terms: {
          applePay: 'never',
          auBecsDebit: 'never',
          bancontact: 'never',
          card: 'never',
          cashapp: 'never',
          googlePay: 'never',
          ideal: 'never',
          paypal: 'never',
          sepaDebit: 'never',
          sofort: 'never',
          usBankAccount: 'never'
        },
        paymentMethodOptions: {
          us_bank_account: {
            verification_method: 'instant',
          },
        },
      };

      const paymentElement = elements.create('payment', paymentElementOptions);
      paymentElement.mount('#payment-element');
    }
  }, [stripePromise])

  useEffect(() => {
    loadStripeAccount()
  }, [])

  const options = {
    mode: 'payment',
    amount: 100,
    paymentMethodCreation: 'manual',
    currency: 'usd',
    setupFutureUsage: 'off_session',
    paymentMethodOptions: {
      us_bank_account: {
        verification_method: 'instant',
      },
    },
  };
 
  return (
    <>
      <div id="payment-element"></div>
    </>
  )
}

export default StripeCheckout
